import React from "react";
import Companies from "./Companies/Companies";
import Packages from "./Packages/Packages";
import MasterNumberDIOD from "./MasterNumberDIOD/MasterNumberDIOD";


const SuperAdmin = () => {
  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-1-1">
                <div className="dashboardIntro">
                  <h3>VPBX MANAGER</h3>
                  <p>
                  Use this page to create company, add packages or add master number.
                  </p>
                </div>
              </div>
              {/* <div className="uk-width-1-3">
                <div className="dashboardIntro uk-text-right">
                  <button>EXPORT DATA</button>
                </div>
              </div> */}

              <div className="uk-width-1-1 ">
                <ul
                  className="uk-subnav callSwitcher"
                  uk-switcher="connect: .callClass"
                >
                  <li>
                    <a href="#">Companies</a>
                  </li>
                  <li>
                    <a href="#">Packages</a>
                  </li>
                  <li>
                    <a href="#">Master number DIOD</a>
                  </li>
                </ul>
              </div>
            </div>
            <ul className="uk-switcher uk-margin callClass">
              <li>
                <Companies/>
              </li>
              <li>
                <Packages/>
              </li>
              <li>
                <MasterNumberDIOD/>
              </li>
              
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperAdmin;
